import { InjectionToken } from '@angular/core';
import { IrisActiveFilterService } from '@iris/modules/module-filters-v2/active-filter';

export const IRIS_ACTIVE_SIDEBAR_FILTER = new InjectionToken<IrisActiveFilterService>('Service providing active sidebar filter');
